function Search(){

    this.build();

}

Search.prototype.build = function(){

    const searchBar = document.querySelector(".search-bar");
    const searchBarBtnOpen = document.querySelectorAll(".js-search-bar-open");
    const searchBarBtnClose = document.querySelector(".js-search-bar-close");
    const searchInput = searchBar.querySelector("input[type='text']");

    searchBarBtnOpen.forEach( (btn) => {
        btn.addEventListener("click", () => {
            console.log("search open");
            document.body.classList.add('search-bar-open');
            searchInput.focus();
        });
    });
    searchBarBtnClose.addEventListener("click", () => {
        document.body.classList.remove('search-bar-open');
    });

};
